export enum TypeSalomConditions {
  InMonths = 'in_months',
  InDay = 'in_days',
}
